import { Injectable } from '@angular/core';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SimpleEntityDataService } from './simple-entity-data.service';
import { SearchableEntityDataEditorService } from '../searchable-entity-data-editor.service';
import { SearchParams } from '../../../search/models/search-params.model';
import { DataTableConfig } from '../../../search/models/data-table-config';
import { SearchEvent } from '../../../search/models/search-event';
import { ITEM_CLICK_EVENT } from '../../../search/search-constants';

@Injectable()
export class SimpleEntityDataEditorService extends SearchableEntityDataEditorService {

  protected dataService: SimpleEntityDataService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  protected refreshAutoPopulatedLookupProperty(row: any, baseProperty: string,
    propertyMap: any, isStartEvent: boolean, hasError: boolean) {
    // if this is a start event
    let isLoading: boolean = false;
    if (isStartEvent && row.cells[baseProperty].cVal && row.cells[baseProperty].cVal !== '') {
      isLoading = true;
    }
    const dependantProps = Object.keys(propertyMap);
    dependantProps.forEach(property => {
      if (property !== baseProperty) {
        if (isStartEvent) {
          row.cells[property].cValPrev = row.cells[property].cVal;
          row.cells[property].cVal = '';
        }
        row.cells[property].isLoading = isLoading;
      }
    });
    if (!isLoading) {
      row.cells[baseProperty].isValueInvalid = hasError;
      const propToFocus = hasError ? baseProperty : this.getNextPropertyToFocus(baseProperty);
      const agGridApi = this.dataService.searchService.getPagedData().aggridApi;
      const rowId = 0;
      if (agGridApi && agGridApi.getFocusedCell()) {
        agGridApi.setFocusedCell(agGridApi.getFocusedCell().rowIndex, propToFocus);
      } else {
        row.focusedCellId = propToFocus;
      }
    }
  }
  /*LFWM-1050 Adding look up params for the simple entity data editor to enable auto suggestion for look up type fields */
  protected getSkuProperty(property) {
    let skuProperty;
    if (this.dataService.entityConfig.getType() === 'PO' || property === 'commodity') {
      skuProperty = 'commodity';
    } else {
      skuProperty = 'sku';
    }
    return skuProperty;
  }
  protected createLookupParamsForColumn(property: any) {
    const lookupParams = new SearchParams();
    lookupParams.isFullFetch = true;
    lookupParams.columnCount = 10;
    lookupParams.defaultSearchColumn = '';
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.showIdAsAHyperLink = true;
    tableConfig.supportFiltering = true;
    lookupParams.dataTableConfig = tableConfig;
    if (property === 'storerKey' || property === 'storerName') {
      lookupParams.tableId = 'storertd';
      lookupParams.idProperty = 'storerName';
    } else if (property === this.getSkuProperty(property)) {
      lookupParams.tableId = 'commoditytd';
      lookupParams.idProperty = 'sku';
    } else if (property === 'sellerName' || property === 'seller') {
      lookupParams.tableId = 'sellertd';
      lookupParams.idProperty = 'sellerName';
    } else if (property === 'carrier' || property === 'carrierKey') {
      lookupParams.tableId = 'carriertd';
      lookupParams.idProperty = 'carrierKey';
    }
    return lookupParams;
  }

  protected getLookupModalTitle(property) {
    switch (property) {

      case 'storerKey': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('storer_Id'));

      case 'storerName': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('storer_Id'));

      case 'sku': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('lbl_commodity'));

      case 'commodity': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('lbl_commodity'));

      case 'toLoc': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('loc_id'));

      case 'putawayLoc': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('loc_id'));

      case 'sellerName': return this.resourceService.get('maintain_storer');

      case 'carrier': return this.resourceService.get('maintain_storer');

      case 'carrierKey': return this.resourceService.get('maintain_storer');

      case 'toId': return this.resourceService.get('lbl_lookup').concat(' ').concat(this.resourceService.get('id'));

      default: return property;
    }
  }
  //[LFWM-1984][Lookup screens search accordion][Added funtion to map subtitle in lookup component]
  protected getLookupModalSubTitle(property) {
    switch (property) {
      case 'storerKey': return this.resourceService.get('storer_Id').concat(' ').concat(this.resourceService.get('lbl_search'));
     
      case 'storerName': return this.resourceService.get('storer_Id').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'sku': return this.resourceService.get('lbl_commodity').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'commodity': return this.resourceService.get('lbl_commodity').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'toLoc': return this.resourceService.get('loc_id').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'putawayLoc': return this.resourceService.get('loc_id').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'sellerName': return this.resourceService.get('maintain_storer').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'carrier': return this.resourceService.get('maintain_storer').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'carrierKey': return this.resourceService.get('maintain_storer').concat(' ').concat(this.resourceService.get('lbl_search'));

      case 'toId': return this.resourceService.get('id').concat(' ').concat(this.resourceService.get('lbl_search'));

      default: return property;
    }
}
  /**
 * method used to emit event when property value using lookup
 */
  public valueChanged(property, prevVal, currentValue) {
    if (prevVal === currentValue) {
      return;
    }
    const valueChangedObject = new Object();
    valueChangedObject['property'] = property;
    valueChangedObject['prevVal'] = prevVal;
    valueChangedObject['newVal'] = currentValue;
    this.dataService.valueChangedPublishEvent(valueChangedObject);

  }
  protected getDependantMapForProperty(property: string) {
    let propMap;
    if (property === 'storerKey') {
      propMap = {
        'storerKey': 'storerName'
      };

    } else {
      return super.getDependantMapForProperty(property);
    }
    return propMap;
  }

  // method to navigate to details page based on selected id
  public navigateToHyperlink(params: any) {
    const searchEvent: SearchEvent = new SearchEvent(ITEM_CLICK_EVENT);
    searchEvent.selectedItemId = params.value.cVal;
    searchEvent.selectedProperty = params.colDef.field;
    searchEvent.selectedRow = params.context.componentParent.searchService
      .getPagedData().pageRows[params.rowIndex];
      params.context.componentParent.searchService.publishEvent(searchEvent);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/searchable-entity/simple-entity/simple-entity-data-editor.service.ts